import { useTenant } from '../../context/TenantContext';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import '../backdesk/backdesk.css';
import './login.css';
import Icon from '../../components/common/Icon';

export default function Login() {
  const tenant = useTenant();
  const { login }  = useAuth();
  const navigate   = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');
  const [step,     setStep]     = useState(1);
  const [showPass, setShowPass] = useState(false);

  function handleUserNext(e) {
    e.preventDefault();
    if (!username.trim()) return;
    setStep(2);
  }

  async function submit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.login({ username, password, method: 'local' });
      login(res.agent, res.token);
      navigate('/backdesk');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="hd-login-page">
      <div className="hd-login-card">

        <div className="hd-login-left">
          <div className="hd-login-icon">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
              <rect x="3"  y="3"  width="8" height="8" rx="2" fill={tenant?.primaryColor || '#0288D1'}/>
              <rect x="15" y="3"  width="8" height="8" rx="2" fill={tenant?.accentColor  || '#4FC3F7'}/>
              <rect x="3"  y="15" width="8" height="8" rx="2" fill={tenant?.accentColor  || '#4FC3F7'}/>
              <rect x="15" y="15" width="8" height="8" rx="2" fill={tenant?.primaryColor || '#0277BD'}/>
            </svg>
          </div>
          <div className="hd-login-service-name">{tenant?.appName || 'HelpDesk TI'}</div>
          <div className="hd-login-service-desc">{tenant?.name || 'Soporte técnico interno'}</div>
        </div>

        <div className="hd-login-right">
          <div className="hd-login-title">Iniciar sesión</div>

          {error && <div className="hd-login-error">{error}</div>}

          {step === 1 && (
            <form onSubmit={handleUserNext}>
              <div className="hd-login-subtitle">Introduzca su usuario para continuar</div>
              <div className="hd-input-wrap">
                <input type="text" placeholder="Usuario" value={username}
                  onChange={e => setUsername(e.target.value)}
                  autoComplete="username" autoFocus />
                <button type="submit" className="hd-btn-arrow">
                  <Icon name="arrow_forward" size={18} style={{color:"#fff"}} />
                </button>
              </div>
            </form>
          )}

          {step === 2 && (
            <form onSubmit={submit}>
              <div className="hd-login-subtitle">Introduzca su contraseña para continuar</div>
              <div className="hd-user-chip">
                <div className="hd-chip-avatar">{username[0]?.toUpperCase()}</div>
                <span>{username}</span>
                <button type="button" className="hd-chip-close"
                  onClick={() => { setStep(1); setError(''); setPassword(''); }}>
                  <Icon name="close" size={14} style={{color:"#BDBDBD"}} />
                </button>
              </div>
              <div className="hd-input-wrap">
                <input type={showPass ? 'text' : 'password'} placeholder="Contraseña"
                  value={password} onChange={e => setPassword(e.target.value)}
                  autoComplete="current-password" autoFocus />
                <button type="button" className="hd-btn-eye" onClick={() => setShowPass(v => !v)}>
                  <Icon name="visibility" size={18} style={{color:"#9E9E9E"}} />
                </button>
                <button type="submit" className="hd-btn-arrow" disabled={loading}>
                  <Icon name="arrow_forward" size={18} style={{color:"#fff"}} />
                </button>
              </div>
            </form>
          )}
        </div>
      </div>

      <div className="hd-login-footer">
        <Icon name="language" size={14} style={{color:"#9E9E9E"}} />
        Español (España)
        <Icon name="expand_more" size={14} style={{color:"#9E9E9E"}} />
      </div>
    </div>
  );
}
